import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';
@Injectable({
    providedIn: 'root'
  })
  export class FineService extends DataService{

    private url =environment.apiUrl + 'api/fine';
    
    constructor(private httpClient: HttpClient) { 
        super(httpClient);
     }
    getFines(model:any){
        return this.httpClient.post(this.url+'/getfines', model)
    }
   
   getFineHistory(instanceId : any){
        return this.httpClient.get(this.url+'/getfinehistory?instanceId='+instanceId)
    }
    payFine(model:any){
          return this.httpClient.post(this.url+'/payfine', model)
    }
  }